import { Link } from "react-router-dom";
import { BrandLogo } from "./BrandName";

export default function HeroSection() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background Video */}
      <div className="absolute inset-0">
        <video
          autoPlay muted loop playsInline
          poster="https://static.wixstatic.com/media/ab775c_bafaeefaaf464fc0845f24a508d29b54f000.jpg/v1/fill/w_1920,h_1080,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/ab775c_bafaeefaaf464fc0845f24a508d29b54f000.jpg"
          className="w-full h-full object-cover"
        >
          <source src="https://video.wixstatic.com/video/ab775c_bafaeefaaf464fc0845f24a508d29b54/720p/mp4/file.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/20" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          <div>
            <p
              data-testid="hero-tagline"
              className="text-[10px] sm:text-xs tracking-[0.35em] uppercase text-white/50 mb-6"
              style={{ fontStyle: "normal" }}
            >
              Designed in Switzerland
            </p>
            <h1
              data-testid="hero-heading"
              className="text-5xl sm:text-6xl lg:text-8xl text-white tracking-tighter leading-[0.85] mb-6"
            >
              Better
              <br />
              Than
              <br />
              Yesterday
            </h1>
            <p
              data-testid="hero-slogan"
              className="text-white/40 text-sm sm:text-base tracking-wide mb-10 max-w-sm leading-relaxed"
            >
              Premium padel performance wear. From the court to the street.
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <Link
                to="/shop"
                data-testid="hero-cta"
                className="inline-block bg-white text-[#0A0A0A] px-10 py-4 text-xs tracking-[0.2em] uppercase hover:bg-white/90 transition-colors duration-300 active:scale-95"
                style={{ fontStyle: "normal" }}
              >
                Shop Collection
              </Link>
              <Link
                to="/about"
                className="inline-block text-white/50 hover:text-white text-xs tracking-[0.15em] uppercase transition-colors duration-300"
                style={{ fontStyle: "normal" }}
              >
                Our Story
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
